import * as yup from 'yup'
import { yupResolver } from '@hookform/resolvers/yup'

const schema = yup
  .object({
    subject: yup
      .string()
      .required('Subject is required')
      .trim()
      .min(1, 'Subject must be at least 1 character'),
    text: yup
      .string()
      .required('Text is required')
      .trim()
      .min(1, 'Text must be at least 1 character'),
  })
  .required()

const resEmailMessage = yupResolver(schema)

export default resEmailMessage
